import { FieldWrapper } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { Input,Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { Grid, GridColumn, GridNoRecords, GridCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { useContext,useState, useEffect } from 'react';
import { docLinks } from './Configuration';
import { DocLinks } from '../services/interfaces';
import {PickupSelection} from '../services/interfaces'; // Add this import if not present
import { SubmitPickupToInfo } from './InfoBoxes';
import { PickupToList } from './FormComponents';
import { SubmissionContext } from './SubmissionFormContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import { ConfirmDialog,AlertDialog } from './ConfirmDialog';
import { getAdCreated } from '../services/apiService';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';

function PickupToForm(){

    const subContext=useContext(SubmissionContext);
    const pageContext=useContext(PageContext);
    const [pickupSelection, setPickupSelection]=useState<PickupSelection[]>([]);
    const [adsForPickup, setAdsForPickup] = useState<any[]>([]);
    const [showConfirm, setShowConfirm]=useState(false);
    const [showAlert, setShowAlert]=useState(false);
    const [adCreated, setAdCreated]=useState(false);
    const [alertTitle,setAlertTitle]=useState("");
    const [alertMessage,setAlertMessage]=useState("");
    const [overwriteWarn, setOverwriteWarn]=useState(false);
    const [showPickupExpire, setShowPickupExpire]= useState(false);
    const pwcChange=(check:CheckboxChangeEvent)=>{
        if (check.target.value){
            subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:true}));
        }else{
            subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:false}));
        }
    }
    
    const insertAdForPickup=()=>{
        let adArray = adsForPickup;
        adArray.push(pickupSelection);
        setAdsForPickup(adArray);
        setPickupSelection([]);
        let pickupString = "";
        adArray.forEach(element => {
            pickupString+=element.element + ",";
        });
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickup:pickupString}));
    }

    const overwriteWarning=()=>{
        const showOverwriteWarning = pageContext?.glSettings.OverwriteWarningOnPickupNoChange;
        //console.log("Show overwrite warning: " + showOverwriteWarning);
        const element=pageContext?.selectedAd.element||"";
        if (element!=""){
            getAdCreated(element).then(data=>{
                const adCreated = data.toString();
                setAdCreated(adCreated);
                //console.log("Ad created:" + adCreated);
            });
        }
    }

    const confirmOverwrite=()=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:false}));
        insertAdForPickup();
    }

    const cancelOverwrite=()=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:true}));
    }

    const closeAlert=()=>{
        setShowAlert(false);
    }


    useEffect(()=>{
        console.log(pickupSelection);
        const elements:string[] =[];
        pickupSelection.forEach((item: PickupSelection) => {
            // Add logic here if needed to process each pickup selection item
            console.log(item);
            elements.push(item.element);
        });
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickup:JSON.stringify(elements)}));
        //var pickupString = pickupSelection.element;
        //subContext?.setSubmitForm(prevObject=>({...prevObject,pickup:pickupSelection.element}));
    },[pickupSelection])

    useEffect(() => {
        overwriteWarning();
        console.log(pageContext?.glSettings);
        
    }, []);
    return(
        <div>    
            <SubmitPickupToInfo/>
            <FieldWrapper>
                <Label className='mb-2'>Select the target ad:</Label>
                <PickupToList value={pickupSelection} setPickup={setPickupSelection} sameCust={true}/>
            </FieldWrapper>
            <FieldWrapper className='mb-2 mt-3'>
                <Checkbox label='This pickup requires changes' onChange={pwcChange} checked={subContext?.submitForm.pickupWithChanges}/>
            </FieldWrapper>
        
            {showConfirm?<ConfirmDialog type="WARN" title='WARNING' message='A document already exists for this ad. Initiating a pickup will overwrite the existing ad document. Are you sure you want to continue?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmOverwrite} onClose={cancelOverwrite}   ></ConfirmDialog>:null}
            {showAlert?<AlertDialog type = "WARN" title={alertTitle} message={alertMessage} confirmButtonText='Ok' onClose={closeAlert} ></AlertDialog>:null}
        </div>
    )

}

export const SubmitPickupTo=(
    //const pageContext = useContext(PageContext);
    //console.log(pageContext);
    <PickupToForm/>
)
